import { render, staticRenderFns } from "./WorkspaceFabricGroupSelection.vue?vue&type=template&id=6360562a&scoped=true&"
import script from "./WorkspaceFabricGroupSelection.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricGroupSelection.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricGroupSelection.vue?vue&type=style&index=0&id=6360562a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6360562a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6360562a')) {
      api.createRecord('6360562a', component.options)
    } else {
      api.reload('6360562a', component.options)
    }
    module.hot.accept("./WorkspaceFabricGroupSelection.vue?vue&type=template&id=6360562a&scoped=true&", function () {
      api.rerender('6360562a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricGroupSelection.vue"
export default component.exports